
/* ===== AI 대화 화면 동기화 (기존 로직 무수정) ===== */
(function(){
  function $(i){ return document.getElementById(i); }
  function syncTurn(){
    try{
      var t=$('chat-turn'); if(!t) return;
      var m=String(t.textContent||'').match(/(\d+)\s*\/\s*(\d+)/);
      if(!m) return;
      var cur=+m[1], tot=+m[2]||8, pct=tot>0?Math.round(cur/tot*100):0;
      var n=$('chat-turn-n'), tt=$('chat-turn-t'), p=$('chat-turn-pct'), b=$('chat-turn-bar');
      if(n) n.textContent=cur;
      if(tt) tt.textContent=tot;
      if(p) p.textContent=pct+'%';
      if(b){ b.style.width=pct+'%'; var pr=b.parentNode; if(pr&&pr.setAttribute) pr.setAttribute('aria-valuenow',pct); }
    }catch(e){}
  }
  function syncQ(){
    try{
      var box=$('chat-msgs'), q=$('pia-chat-q'); if(!box||!q) return;
      var kids=box.children; if(!kids.length) return;
      for(var i=kids.length-1;i>=0;i--){
        var el=kids[i];
        var isUser = el.className && /justify-end/.test(el.className);
        if(isUser) continue;
        var tx=(el.textContent||'').replace(/\s+/g,' ').trim();
        if(tx && tx.length>1){
          if(q.textContent.replace(/\s+/g,' ').trim()!==tx){
            q.textContent=tx;
            try{
        /* 자유대화 답변은 speakReply 가 이미 읽는다.
           여기서 또 읽으면 speechSynthesis.cancel() 이 앞 문장을 끊어 말이 뒤섞인다. */
        var _inChat=false;
        try{ var _cs=document.querySelector('section[data-view]:not(.hidden)'); _inChat=!!(_cs&&_cs.dataset.view==='chat'); }catch(e){}
        if(window.PIA && window.PIA.ttsOn && !_inChat) window.PIA.speak(tx);
      }catch(e){}
          }
          return;
        }
      }
    }catch(e){}
  }
  function syncMic(){
    try{
      var b=$('chat-mic'); if(!b) return;
      var rec = (typeof window._globalRecordingProxy!=='undefined') ? window._globalRecordingProxy : null;
      var on = b.classList.contains('animate-pulse') || /⏹/.test(b.textContent||'');
      b.setAttribute('aria-pressed', on?'true':'false');
    }catch(e){}
  }
  /* 빠른답변 칩 선화 아이콘 (표시 전용 · 텍스트/전송 로직 무변경) */
  var QI={
    friend:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="8" r="3"/><path d="M3 20c0-3.3 2.7-5.5 6-5.5s6 2.2 6 5.5"/><path d="M17 4h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-1l-2 2v-2h-1a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"/></svg>',
    sport:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="m12 7 4 2.9-1.5 4.7h-5L8 9.9z"/><path d="M12 3v4M3.6 9.6 8 9.9M20.4 9.6 16 9.9M6.5 19.5 9.5 14.6M17.5 19.5 14.5 14.6"/></svg>',
    rest:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12V8a2 2 0 0 1 4 0v4"/><path d="M15 12V8a2 2 0 0 1 4 0v4"/><path d="M4 12h16v5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"/><path d="M6 19v2M18 19v2"/></svg>',
    study:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 5.5A2.5 2.5 0 0 1 5.5 3H11v16H5.5A2.5 2.5 0 0 0 3 21.5z"/><path d="M21 5.5A2.5 2.5 0 0 0 18.5 3H13v16h5.5a2.5 2.5 0 0 1 2.5 2.5z"/></svg>',
    mood:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M8.5 15.5q3.5-2.5 7 0"/><path d="M9 9.5h.01M15 9.5h.01"/></svg>',
    dream:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v2M12 19v2M3 12h2M19 12h2M6 6l1.5 1.5M16.5 16.5 18 18M18 6l-1.5 1.5M7.5 16.5 6 18"/><circle cx="12" cy="12" r="3.5"/></svg>',
    unknown:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><path d="M9.5 9.2a2.6 2.6 0 0 1 5 .9c0 1.7-2.5 2-2.5 3.4"/><path d="M12 17h.01"/></svg>'
  };
  var QRULE=[
    [/\uce5c\uad6c|\uc0ac\ub78c|\uac19\uc774|\uc774\uc57c\uae30|\ub300\ud654/,'friend'],
    [/\uccb4\uc721|\uc6b4\ub3d9|\ucd95\uad6c|\ub18d\uad6c|\uc2a4\ud3ec\uce20|\uac8c\uc784/,'sport'],
    [/\uc26c|\ud63c\uc790|\uc7a0|\ud734\uc2dd|\uc9d1/,'rest'],
    [/\uad6d\uc5b4|\uc218\ud559|\uc601\uc5b4|\uacfc\ud559|\uacf5\ubd80|\uc218\uc5c5|\ubc30\uc6b0/,'study'],
    [/\uae30\ubd84|\uc6b0\uc6b8|\ud654\ub098|\uc2ac\ud504|\uc2f8\uc6e0|\ud798\ub4e4/,'mood'],
    [/\uafc8|\uc9c4\ub85c|\uc9c1\uc5c5|\ub418\uace0 \uc2f6|\uc7a5\ub798/,'dream']
  ];
  function decorateQuick(){
    try{
      var w=$('chat-quick-wrap'); if(!w) return;
      [].forEach.call(w.querySelectorAll('.chat-quick'),function(b){
        if(b.querySelector('.pia-qk__ic')) return;
        var t=(b.textContent||'').trim(), key='unknown';
        for(var i=0;i<QRULE.length;i++){ if(QRULE[i][0].test(t)){ key=QRULE[i][1]; break; } }
        b.className='chat-quick pia-qk__b';
        b.setAttribute('type','button');
        b.innerHTML='<span class="pia-qk__ic" aria-hidden="true">'+QI[key]+'</span><span>'+t+'</span>';
      });
    }catch(e){ if(window.console) console.error('\ube60\ub978\ub2f5\ubcc0 \uc544\uc774\ucf58 \uc2e4\ud328:', e); }
  }
  /* [FIX 2026-08-22] 옵저버 콜백이 자기가 감시하는 DOM 을 다시 고치면
     (특히 decorateQuick 은 감시 대상의 innerHTML 을 교체한다) 무한 되먹임이 되어
     첫 대화 응답 직후 메인스레드가 멈춘다. 공통 가드로 감싼다:
     · 재진입 금지(_busy) · rAF 디바운스 · 콜백 실행 중에는 옵저버 일시 정지 */
  function guarded(mo_ref, fn){
    var busy=false, queued=false;
    return function(){
      if(busy){ queued=true; return; }
      busy=true;
      requestAnimationFrame(function(){
        var mo=mo_ref.v;
        try{ if(mo) mo.disconnect(); }catch(e){}
        try{ fn(); }catch(e){ if(window.console) console.error('옵저버 콜백 오류:', e); }
        try{ if(mo && mo_ref.reobserve) mo_ref.reobserve(); }catch(e){}
        busy=false;
        if(queued){ queued=false; }
      });
    };
  }
  function watchEl(el, opts, fn){
    if(!el || !window.MutationObserver) return;
    var ref={v:null};
    var cb=guarded(ref, fn);
    var mo=new MutationObserver(cb);
    ref.v=mo;
    ref.reobserve=function(){ try{ mo.observe(el, opts); }catch(e){} };
    ref.reobserve();
  }
  function boot(){
    var bot=$('pia-chat-bot'); if(bot && !bot.innerHTML && window.PIA && PIA.botImg) bot.innerHTML=PIA.botImg('hero','');
    var t=$('chat-turn'), box=$('chat-msgs'), mic=$('chat-mic');
    /* characterData 는 타이핑 애니메이션 한 글자마다 발동한다. 뺀다. */
    watchEl(t,   {childList:true,subtree:true},                  syncTurn);
    watchEl(box, {childList:true,subtree:true},                  function(){ syncQ(); });
    watchEl(mic, {attributes:true,childList:true,subtree:true},  syncMic);
    watchEl($('chat-quick-wrap'), {childList:true},              function(){ decorateQuick(); });
    syncTurn(); syncQ();
    decorateQuick();
  }
  var _o=showView;
  showView=function(n){ _o(n); try{ document.body.classList.toggle('pia-on-result', n==='result'); }catch(e){} if(n==='chat') setTimeout(boot,150); };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setTimeout(boot,300); });
  else setTimeout(boot,300);
})();

